<script setup lang="ts">

useSeoMeta({
  title: 'Tus Noticias Today - Las Mejores Noticias de Hoy en un Solo Lugar',
  description: 'Descubre las noticias más relevantes del día en Tus Noticias Today. Las últimas actualizaciones de periódicos nacionales e internacionales, todo en un solo sitio.',
  ogTitle: 'Tus Noticias Today - Las Mejores Noticias de Hoy en un Solo Lugar',
  ogDescription: 'Descubre las noticias más relevantes del día en Tus Noticias Today. Las últimas actualizaciones de periódicos nacionales e internacionales, todo en un solo sitio.',
  twitterTitle: 'Tus Noticias Today - Las Mejores Noticias de Hoy en un Solo Lugar',
  twitterDescription: 'Descubre las noticias más relevantes del día en Tus Noticias Today. Las últimas actualizaciones de periódicos nacionales e internacionales, todo en un solo sitio.',
  twitterCard: 'summary'
})
useHead({
  htmlAttrs: {
    lang: 'es'
  },
})

</script>

<template>
  <UApp>
    <div>
      <SiteHeader />
      <main>
        <NuxtPage />
      </main>
    </div>
  </UApp>
</template>
